import { useEffect } from 'react';
import { Box, Container } from '@mui/material';
import { datadogRum } from "@datadog/browser-rum";

import { useCases, useMe, useShifts } from '../api';
import { AvailableShifts } from './AvailableShifts';
import Spinner from './Spinner';

const appStyle = {
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
};
const containerStyle = {
  height: 'inherit',
  padding: 0,
};
const contentStyle = {
  height: 'inherit',
  width: 'inherit',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
};
const bodyStyle = {
  overflow: 'scroll',
  height: 'inherit',
  width: 'inherit',
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'flex-start',
};

const Shyftr = ({isFilterOn}) => {
  const { data: me } = useMe();
  const { isLoading: casesLoading } = useCases();
  const { isLoading: shiftsLoading } = useShifts();
  const showSpinner = casesLoading || shiftsLoading;

  useEffect(() => {
    if (me === undefined) {
      return;
    }

    datadogRum.init({
				applicationId: process.env.REACT_APP_DATADOG_APPLICATION_ID,
				clientToken: process.env.REACT_APP_DATADOG_CLIENT_TOKEN,
				// `site` refers to the Datadog site parameter of your organization
				// see https://docs.datadoghq.com/getting_started/site/
				site: "datadoghq.com",
				service: process.env.REACT_APP_DATADOG_SERVICE,
				env: process.env.REACT_APP_DATADOG_ENV,
				// version: process.env.REACT_APP_VERSION,
				sessionSampleRate: 100,
				sessionReplaySampleRate: 100,
				defaultPrivacyLevel: "allow",
				trackResources: true,
				trackLongTasks: true,
				trackUserInteractions: true,
			});

			datadogRum.onReady(() => {
				datadogRum.setUser({
					id: me.employeeId,
					name: me.username,
				});
			});
  }, [me]);

  return (
    <Box sx={appStyle}>
      <Container sx={containerStyle} maxWidth="sm">
        <Box sx={contentStyle}>
          {showSpinner && <Spinner />}
          {!showSpinner &&
            <Box sx={bodyStyle} style={{ display: 'flex' }}>
              <AvailableShifts isFilterOn={isFilterOn} />
            </Box>
          }
        </Box>
      </Container>
    </Box>
  );
};

export { Shyftr };
